import React from 'react';
import { Lock } from 'lucide-react';
import { motion } from 'framer-motion';
export function Hero() {
  const scrollToPricing = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const element = document.getElementById('pricing');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden" data-id="element-121">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/d6PmnHKgNL93pLp5zi7wza/BANNER.png")'
    }} data-id="element-122">
        <div className="absolute inset-0 bg-navy/85 mix-blend-multiply" data-id="element-123"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20 text-center" data-id="element-124">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-125">
          <h1 className="font-heading text-5xl md:text-7xl font-extrabold text-white mb-6 tracking-tight" data-id="element-126">
            CÓDIGO CALMA
          </h1>
          <p className="text-xl md:text-3xl font-heading font-semibold text-white mb-8 leading-tight" data-id="element-127">
            El Método de 21 Días para Dominar tu Estrés Laboral, Recuperar tu
            Sueño y Poner Límites a tu Jefe Sin Miedo a Ser Despedido.
          </p>
          <p className="text-lg md:text-xl text-gray-300 mb-12 max-w-3xl mx-auto leading-relaxed" data-id="element-128">
            El único sistema táctico diseñado para el profesional chileno que
            sobrevive al Metro, los tacos y la falta de tiempo.
          </p>

          <div className="flex flex-col items-center gap-4" data-id="element-129">
            <a href="#pricing" onClick={scrollToPricing} className="w-full sm:w-auto bg-orange hover:bg-orange-500 text-white font-bold text-lg md:text-xl py-4 px-8 rounded-lg shadow-[0_0_20px_rgba(230,126,34,0.4)] transition-all transform hover:scale-105 hover:shadow-[0_0_30px_rgba(230,126,34,0.6)]" data-id="element-130">
              SÍ, QUIERO CÓDIGO CALMA POR $6.390 CLP
            </a>
            <div className="flex items-center gap-2 text-sm text-gray-400 mt-2" data-id="element-131">
              <Lock size={16} data-id="element-132" />
              <span data-id="element-133">
                Pago seguro vía Mercado Pago. Acceso inmediato. Garantía de 7
                días.
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}